import { Shield, Server, HeadphonesIcon, Award } from "lucide-react";

const Trust = () => {
  const trustItems = [
    {
      icon: Shield,
      title: "Datenschutz nach DSGVO-Prinzipien",
      description: "Ihre Daten bleiben in Deutschland und sind nach aktuellen Standards geschützt.",
    },
    {
      icon: Server,
      title: "Deutsche Server",
      description: "Hosting ausschließlich auf zertifizierten Servern in Deutschland.",
    },
    {
      icon: HeadphonesIcon,
      title: "Persönlicher Support",
      description: "Einrichtungsservice und individuelle Schulungen für Ihr Team.",
    },
    {
      icon: Award,
      title: "Made in Germany",
      description: "Entwickelt und betreut von einem erfahrenen deutschen Team.",
    },
  ];

  const certifications = [
    { label: "ISO-9001", sublabel: "Dokumentenlenkung", topText: "Prozesse orientiert an" },
    { label: "ArbZG", sublabel: "Dokumentationspflicht", topText: "Zeiterfassung unterstützt" },
    { label: "FOP", sublabel: "Software", topText: "powered by", isLogo: true },
    { label: "GoBD", sublabel: "für Steuerunterlagen", topText: "Buchhaltung unterstützt" },
    { label: "ZuGFeRD PDF", sublabel: "Version 3.0.1 und höher", topText: "Rechnungsstellung erfüllt", secondLine: "X-Rechnung" },
  ];

  return (
    <section className="relative overflow-hidden bg-primary py-20 lg:py-28">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="container relative">
        <div className="mx-auto mb-16 max-w-3xl text-center">
          <h2 className="mb-4 font-display text-3xl font-bold text-primary-foreground sm:text-4xl">
            Vertrauen Sie auf deutsche Qualität
          </h2>
          <p className="text-lg text-primary-foreground/70">
            Sicherheit, Compliance-Unterstützung und persönliche Betreuung – das zeichnet uns aus.
          </p>
        </div>

        <div className="mb-20 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {trustItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-2xl bg-primary-foreground/5 p-6 transition-all duration-300 hover:bg-primary-foreground/10"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-primary-foreground/10">
                <item.icon className="h-6 w-6 text-primary-foreground" />
              </div>
              <h3 className="mb-2 font-display text-lg font-bold text-primary-foreground">
                {item.title}
              </h3>
              <p className="text-sm leading-relaxed text-primary-foreground/70">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mb-16 h-px bg-primary-foreground/10" />

        <div className="mx-auto max-w-5xl">
          <p className="mb-10 text-center text-sm font-medium uppercase tracking-wider text-primary-foreground/50">
            Standards & Konformität
          </p>

          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-5">
            {certifications.map((cert) => (
              <div
                key={cert.label}
                className="group flex flex-col items-center justify-center rounded-xl bg-primary-foreground/5 px-4 py-6 text-center transition-all duration-300 hover:bg-primary-foreground/10"
              >
                <span className="mb-1 text-[10px] font-medium uppercase tracking-wide text-primary-foreground/50">
                  {cert.topText}
                </span>
                <span className={`font-display font-bold text-primary-foreground ${cert.isLogo ? 'text-xl text-accent' : 'text-lg'}`}>
                  {cert.label}
                </span>
                {cert.secondLine && (
                  <span className="font-display text-sm font-bold text-primary-foreground">
                    {cert.secondLine}
                  </span>
                )}
                <span className="mt-1 text-[10px] text-primary-foreground/50">
                  {cert.sublabel}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trust;
